import { render, staticRenderFns } from "./CaseCustomMenus.vue?vue&type=template&id=829b0f32&scoped=true&"
import script from "./CaseCustomMenus.vue?vue&type=script&lang=js&"
export * from "./CaseCustomMenus.vue?vue&type=script&lang=js&"
import style0 from "./CaseCustomMenus.vue?vue&type=style&index=0&id=829b0f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829b0f32",
  null
  
)

export default component.exports